var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(-1018 -740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 64,
    height: 64,
    transform: "translate(1018 740)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(618.308 35.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M417.394,760.766a8.815,8.815,0,0,0,1.686,1.619l24.8-14.3a4.143,4.143,0,0,0,1.867-3.236l.01-27.038-6.868-5.286-.529-.1-7.449-.125-12.552,7.2a3.835,3.835,0,0,0-.961.806Z",
    transform: "translate(0.326 0.47)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M417.879,760.708A8.729,8.729,0,0,0,419.194,762l24.572-14.17a3.753,3.753,0,0,0,1.671-2.893l.01-26.841-6.638-5.112-.442-.085-7.272-.114-12.455,7.144a3.258,3.258,0,0,0-.761.615v40.164Zm1.288,2.159a.439.439,0,0,1-.229-.069,9.391,9.391,0,0,1-1.763-1.7.389.389,0,0,1-.089-.249v-40.46a.376.376,0,0,1,.1-.255,4.067,4.067,0,0,1,1.067-.894l12.551-7.2a.372.372,0,0,1,.2-.051l7.449.122.6.114a.415.415,0,0,1,.164.074l6.868,5.282a.4.4,0,0,1,.155.316l-.01,27.038a4.5,4.5,0,0,1-2.068,3.579l-24.794,14.3a.38.38,0,0,1-.2.053Z",
    transform: "translate(0.239 0.383)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M436.754,722.8l3.458-1.994c1.7-.932,2.651-1.752.932-3.09l-7.3-5.688,2.915,4.437Z",
    transform: "translate(4.993 0.394)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M435.575,713.9l1.6,2.434a.381.381,0,0,1,.067.22v5.652l2.863-1.651c.75-.41,1.6-.936,1.644-1.4.028-.347-.4-.757-.756-1.036l-5.415-4.217Zm1.267,9.387a.369.369,0,0,1-.2-.054.39.39,0,0,1-.2-.344l.005-6.217-2.852-4.339a.394.394,0,0,1,.571-.529l7.3,5.691c.76.592,1.107,1.154,1.059,1.723-.064.791-.864,1.381-2.042,2.023l-3.449,1.992a.374.374,0,0,1-.192.056Z",
    transform: "translate(4.905 0.306)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M419.319,762.767l-2.2-1.272a1.4,1.4,0,0,1-.566-1.248l.01-36.921a4.247,4.247,0,0,1,1.928-3.338l13.6-7.85c2.01-1.133,3.121-1.7,5.492-.571a7.43,7.43,0,0,1,4.08,5.207v6.335l-2.368-1.361v-4.723a3.775,3.775,0,0,0-5.73-3.191L420.7,721.259a4.246,4.246,0,0,0-1.927,3.338l-.014,36.925a1.406,1.406,0,0,0,.563,1.245Z",
    transform: "translate(0.087 0.088)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M435.4,711.429a6.363,6.363,0,0,0-3.028,1.141l-13.6,7.85a3.844,3.844,0,0,0-1.728,3.009l-.014,36.905c.051.528.06.646.421.942l1.015.585c-.006-.071-.014-.141-.021-.216l.01-36.962a4.637,4.637,0,0,1,2.112-3.67l12.882-7.435a4.276,4.276,0,0,1,4.352.027,4.22,4.22,0,0,1,1.973,3.515v4.485l1.58.908.005-5.652a7.087,7.087,0,0,0-3.858-4.85,4.9,4.9,0,0,0-2.1-.583ZM419.406,763.25a.389.389,0,0,1-.2-.054l-2.2-1.273a1.8,1.8,0,0,1-.76-1.551l.01-36.958a4.638,4.638,0,0,1,2.108-3.674l13.619-7.856c2.139-1.2,3.37-1.777,5.861-.585a7.8,7.8,0,0,1,4.3,5.492V723.2a.4.4,0,0,1-.592.344l-2.37-1.362a.4.4,0,0,1-.2-.343V717.11a3.45,3.45,0,0,0-1.607-2.834,3.41,3.41,0,0,0-3.552,0l-12.847,7.416a3.824,3.824,0,0,0-1.732,3.01l-.01,36.908c.05.525.06.646.421.938a.4.4,0,0,1-.253.7Z",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M419.319,760.24l-2.2-1.272a1.4,1.4,0,0,1-.566-1.248l.01-36.921a3.831,3.831,0,0,1,.151-.942l2.2,1.273a4.1,4.1,0,0,0-.148.94l-.014,36.925a1.411,1.411,0,0,0,.567,1.245Z",
    transform: "translate(0.087 2.615)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M417.072,720.559a2.933,2.933,0,0,0-.027.343l-.014,36.9c.051.528.06.646.421.942l1.015.585c-.006-.071-.014-.141-.021-.216l.01-36.962a4.41,4.41,0,0,1,.091-.747l-1.476-.851Zm2.334,40.164a.39.39,0,0,1-.2-.054L417,759.4a1.8,1.8,0,0,1-.76-1.551l.01-36.958a4.226,4.226,0,0,1,.162-1.044.4.4,0,0,1,.231-.266.408.408,0,0,1,.348.023l2.2,1.275a.4.4,0,0,1,.185.444,3.387,3.387,0,0,0-.137.855l-.01,36.908c.05.525.06.643.421.938a.4.4,0,0,1,.069.531A.384.384,0,0,1,419.406,760.723Z",
    transform: "translate(0 2.527)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M434.8,733.957a4.027,4.027,0,0,0-1.82,3.151c0,1.161.818,1.632,1.82,1.053a4.031,4.031,0,0,0,1.82-3.155C436.626,733.847,435.81,733.374,434.8,733.957Z",
    transform: "translate(4.75 6.544)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M435.092,734.389a3.645,3.645,0,0,0-1.623,2.807.926.926,0,0,0,.338.838.938.938,0,0,0,.891-.128,3.651,3.651,0,0,0,1.62-2.813.728.728,0,0,0-1.226-.7Zm-1.009,4.5a1.3,1.3,0,0,1-.673-.175,1.649,1.649,0,0,1-.734-1.52,4.412,4.412,0,0,1,2.018-3.494h0a1.494,1.494,0,0,1,2.412,1.391,4.417,4.417,0,0,1-2.018,3.5,2.082,2.082,0,0,1-1.005.3Z",
    transform: "translate(4.662 6.456)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M422.045,738.436a.394.394,0,0,1-.343-.2.4.4,0,0,1,.144-.542l13-7.5a.391.391,0,0,1,.538.141.4.4,0,0,1-.145.542l-13,7.5a.381.381,0,0,1-.194.059Z",
    transform: "translate(1.534 5.533)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M422.045,735.748a.394.394,0,0,1-.343-.2.4.4,0,0,1,.144-.542l16.5-9.529a.4.4,0,0,1,.4.687l-16.507,9.528A.37.37,0,0,1,422.045,735.748Z",
    transform: "translate(1.534 4.195)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M422.045,732.8a.392.392,0,0,1-.343-.2.4.4,0,0,1,.144-.54l16.5-9.53a.4.4,0,0,1,.4.688l-16.507,9.526a.372.372,0,0,1-.194.056Z",
    transform: "translate(1.534 3.357)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M422.045,743.3a.394.394,0,0,1-.2-.736l4.3-2.483a.4.4,0,0,1,.393.687l-4.294,2.479a.381.381,0,0,1-.2.053Z",
    transform: "translate(1.534 8.337)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M422.045,724.167a.392.392,0,0,1-.343-.2.4.4,0,0,1,.144-.54l7.7-4.439a.394.394,0,1,1,.394.682l-7.7,4.443A.37.37,0,0,1,422.045,724.167Z",
    transform: "translate(1.534 2.353)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M435.349,733.374a6.168,6.168,0,0,0-2.789,4.827,1.44,1.44,0,0,0,2.391,1.383,6.171,6.171,0,0,0,2.788-4.829,1.437,1.437,0,0,0-2.39-1.38Zm-1.531,7.356a1.907,1.907,0,0,1-.974-.254,2.474,2.474,0,0,1-1.073-2.275,6.941,6.941,0,0,1,3.185-5.512h0a2.2,2.2,0,0,1,3.575,2.065,6.943,6.943,0,0,1-3.181,5.512,3.083,3.083,0,0,1-1.532.464Z",
    transform: "translate(4.405 6.124)",
    fill: "#2874e7",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCategory);
export default __webpack_public_path__ + "static/media/tax-category.4add51b4839ae47414cdcbc981015b2c.svg";
export { ForwardRef as ReactComponent };